const StatCard = ({
  title,
  value,
  color,
}: {
  title: string
  value: number | string
  color?: string
}) => (
  <div className="stats shadow overflow-hidden">
    <div className="stat">
      <div className="stat-title text-ellipsis overflow-hidden">{title}</div>
      <div className={`stat-value ${color || ''}`}>{value}</div>
    </div>
  </div>
)

export { StatCard }
